import {ImageOpInputsOrNodes, NativeImageSource} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/create-image/definition"
import {ImageOpCreateImageHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/create-image/hal"
import {colorFromRemotelyColorLike} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-utils"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeCreateImage"}

@registerImageOpNode
export class ImageOpNodeCreateImage extends BasicSpecializingImageOpNode<typeof definition, ImageOpCreateImageHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpCreateImageHal, parameters)
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const evaluatedParameters = await evaluator.getAll(parameters)
        if (evaluatedParameters.data instanceof Float32Array || evaluatedParameters.data instanceof NativeImageSource) {
            throw new Error("Only constant initial data is supported in ImgProc")
        }
        return evaluator.context.createEmptyImage(evaluatedParameters.descriptor, colorFromRemotelyColorLike(evaluatedParameters.data))
    }
}
